import { registerPlugin } from '@capacitor/core';
const SiriShortcuts = registerPlugin('SiriShortcuts');
export * from './definitions';
export { SiriShortcuts };
//# sourceMappingURL=index.js.map